import { makeAutoObservable } from "mobx"
import { apiClient } from "api/trpc/trpc-client"
import type { MindsetDto } from "@gap/backend/app-services/mindset/models/MindsetDto"
import variables from "variables/variables"
import Loader from "reusable/mobx-helpers/Loader"

interface MindsetImageTabStoreProps {
   onAdd: (mindsetId: string, orgId: string) => void
}

export default class MindsetImageTabStore {
   sp: MindsetImageTabStoreProps
   mindsets: MindsetDto.list = []
   loader = new Loader(true)

   constructor(sp: MindsetImageTabStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get mindsetsWithImages() {
      return this.mindsets.filter(m => m.imageFileUrl)
   }

   handleClick = (event: React.MouseEvent<HTMLElement>) => {
      const mindsetId = event.currentTarget.getAttribute("data-id")
      if (!mindsetId) return

      this.sp.onAdd(mindsetId, variables.gapOrgId)
   }

   fetch = async () => {
      await this.loader.executeLoading(async () => {
         this.mindsets = await apiClient.mindset.list.query()
      })
   }
}
